'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { TSidebarProps } from '../model';

export const Sidebar = ({ sidebarLinks, sidebarIcon }: TSidebarProps) => {
  const pathname = usePathname();

  return (
    <section className='bg-hover rounded-md sticky right-0 top-0 hidden md:flex flex-col justify-between overflow-y-auto min-h-[calc(100svh_-_265px)] p-3 min-w-[250px]'>
      {sidebarIcon ? (
        <div className='flex items-center justify-center flex-col gap-1'>{sidebarIcon}</div>
      ) : null}
      <div className='border-b border-border' />
      <div className='flex flex-1 flex-col gap-2 pt-5 pb-[10.24px]'>
        {sidebarLinks?.map((item) => {
          const isActive = pathname === item.route || pathname.startsWith(`${item.route}/`);

          return (
            <Link
              key={item.route}
              href={item.route}
              onClick={item.clickHandler}
              className={`${
                isActive ? 'bg-blue-1 text-white' : 'text-text hover:bg-background hover:text-text'
              } flex items-center justify-start gap-4 py-4 px-2 rounded-lg`}
            >
              {item.icon}
              <p
                data-testid={item.id ? `sidebar-${item.id}` : undefined}
                className='body-12-bold leading-[150%] whitespace-nowrap'
              >
                {item.label}
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
